"use client";
import messages from "../../../messages/en";
import React from "react";
import { Button } from "@/components/ui/button";
import { sendGTMEvent } from "@next/third-parties/google";
import { ArrowUpRight } from "@mynaui/icons-react";
import { useLocale } from "next-intl";
import { useRouter } from "next/navigation";
export default function UserStoryButton({ text, index }) {
  const locale = useLocale();
  const router = useRouter();
  function redirect() {
    router.push(`/${locale}/${index % 2 == 0 ? "scanner" : "multichat"}`);
  }
  return (
    <Button
      onClick={() => {
        redirect();
        sendGTMEvent({
          event: `${
            "homepage_userstory_click_" +
            messages.homepage.userstory[`block${index + 1}buttontext`]
              .replace(/\s+/g, "")
              .toLowerCase()
          }`,
        });
      }}
      className={`w-[280px] ${index % 2 == 0 ? "bg-primary " : "border border-white dark:text-white hover:bg-white/10  bg-transparent"}  text-primary-foreground   `}
      size="xl"
    >
      {text}
      <ArrowUpRight style={{ width: "24px", height: "24px" }} />
    </Button>
  );
}
